import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Anchors = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  display: ${props => props.visible ? 'block' : 'none'}
`
const Anchor = styled.div`
  position: absolute;
  width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};;
  border-radius: 50%;
  ${props => props.top ? `top: -${props.size / 2 + 1}px;` : ''}
  ${props => props.left ? `left: -${props.size / 2 + 1}px;` : ''}
  ${props => props.bottom ? `bottom: -${props.size / 2 + 1}px;` : ''}
  ${props => props.right ? `right: -${props.size / 2 + 1}px;` : ''}
  ${props => props.horizontalCenter ? `left: calc(50% - ${props.size / 2 - 1}px);` : ''}
  ${props => props.verticalCenter ? `top: calc(50% - ${props.size / 2}px);` : ''}
  background-color: #fff;
`

const ResizeAnchors = (props) => (
  <Anchors visible={props.visible}>
    <Anchor top left size={props.size} />
    <Anchor top right size={props.size} />
    <Anchor bottom left size={props.size} />
    <Anchor bottom right size={props.size} />
    <Anchor top horizontalCenter size={props.size} />
    <Anchor bottom horizontalCenter size={props.size} />
    <Anchor left verticalCenter size={props.size} />
    <Anchor right verticalCenter size={props.size} />
  </Anchors>
)

ResizeAnchors.defaultProps = {
  size: 10
}

ResizeAnchors.propTypes = {
  visible: PropTypes.bool,
  size: PropTypes.number
}

export default ResizeAnchors



// WEBPACK FOOTER //
// ./src/components/common/ResizeAnchors.js